import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mu-chip',
  templateUrl: './mu-chip.component.html',
  styleUrls: ['./mu-chip.component.sass'],
})
export class MuChipComponent {
  @Input() label: string;
  @Input() styleClass: string;
}
